import moment from "moment/moment";

export const getDayStart = (timeStart) => {
    const dayStart = new Date(timeStart * 1000);
    dayStart.setUTCMilliseconds(0);
    dayStart.setUTCSeconds(0);
    dayStart.setUTCMinutes(0);
    dayStart.setUTCHours(0);

    return dayStart;
}

export const getCurrentTZdayEnd = (date, format) => {
    let dayEnd = moment(date).add(1, 'days').hour(0).minute(0).second(0).millisecond(0);
    if (format === 'unix') {
        dayEnd = dayEnd.unix();
    }
    return dayEnd;
}

export const getStreamDays = (timeStart, timeStop) => {

    const arr = [];

    if (timeStart && timeStop) {
        for (const dayStart = new Date(new Date(timeStart * 1000).setHours(0, 0, 0, 0)); dayStart <= new Date(timeStop * 1000); dayStart.setDate(dayStart.getDate() + 1)) {
            arr.push(new Date(dayStart))
        }
    }

    return arr;
}

export const checkIntersection = (activeRange, targetRange) => {
    if (!activeRange || !targetRange) return false;

    const { start, end } = activeRange;
    const { start: targetStart, end: targetEnd } = targetRange;

    return start >= targetStart && start < targetEnd
        || end > targetStart && end <= targetEnd
        || start < targetStart && end > targetEnd
}